import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class FreeConsultationPopup extends Component {
  constructor() {
    super();
    this.state = {
      data_view:'',
      send_msg:','
    };
  }

componentDidMount(){
  this.get_user_free_consultation_view();
}
get_user_free_consultation_view(){
  let cutThis = this;
  var id = cutThis.props.id;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('id',id);
   body.append('web_token',web_token);
   body.append('function','view_free_consultation_data');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
   }else{
     url = "/php/admin_free_consultation_url.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      if(data['code']==1){
        var msg = data['msg'];
        cutThis.load_data(msg);
      }else{
        //window.location.href = '/';
      }

    })
    .catch(function (error) {
        console.log(error);
    });
}

load_data(msg){
  var data_view = [];
  var action_flag = msg['action_flag'];
  var page_titlte = msg['subject_matter'];
  var write_flag = msg['write_flag'];
  $('#page_titlte').text(page_titlte);
  var message_data = msg['message'];
  var message_length = message_data.length;
  for(var i=0; i < message_length; i++){
    let user_type_class = 'receiver';
    let user_type = message_data[i]['user_type'];
    let added_date = message_data[i]['added_date'];
    let message_info = message_data[i]['message'];
    let seen_flag = message_data[i]['seen_flag'];
    if(user_type==2){
      user_type_class = 'sender';
      added_date = message_data[i]['update_date'];
    }
    var seen_tag = <i className="fa fa-eye-slash" aria-hidden="true"></i>;
    if(seen_flag==1){
      seen_tag = <i className="fa fa-eye seen_icon" aria-hidden="true"></i>;
    }
    data_view.push(
      <div className={"message-content "+user_type_class}>
        <label for="">{added_date+" "}{seen_tag}</label>
        <div className="msg-block">
          <p>
            {message_info}
          </p>
        </div>
      </div>
    );
  }
  this.setState({data_view});

  var main_count = msg['main_count'];
  var added_count = msg['added_count'];
  var send_msg = [];
  if(write_flag==2 && Number(added_count)<Number(main_count) && action_flag==1){
      send_msg.push(
        <div className="chat-footer">
        <div className="input-group md-form form-sm form-2 pl-0">
          <input className="form-control my-0 py-1 red-border" type="text" id="new_message" neme="new_message" placeholder="Write a message..." maxlength="550"/>
          <div className="input-group-append">
            <button className="btn input-group-text red lighten-3" id="basic-text1" onClick={this.send_new_message.bind(this,msg)}>
              <i className="fa fa-paper-plane" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }else if(action_flag==0){
      send_msg.push(
        <div className="chat-footer">
        <div className="input-group md-form form-sm form-2 pl-0">

          <div className="input-group-append">
            <button className="btn input-group-text red lighten-3" id="basic-text1" onClick={this.active_subject_matter.bind(this,msg)}>
              <i className="fa fa-check-square" aria-hidden="true"> Active</i>
            </button>
          </div>
        </div>
      </div>
    );
  }
  this.setState({send_msg});
}

send_new_message(msg){
  var user_id         = msg['user_id'];
  let cutThis         = this;
  var id              = cutThis.props.id;
  var new_message     = window.isNullAndUndef($("#new_message").val());
  var web_token       = window.isNullAndUndef($('#web_token').val());
  if(new_message && web_token){
    var body = new FormData();
    body.append('id',id);
    body.append('added_user_id',user_id);
    body.append('message',new_message);
    body.append('web_token',web_token);
    body.append('function','add_new_message_free_consulting_data');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
    }else{
      url = "/php/admin_free_consultation_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['code']){
          cutThis.get_user_free_consultation_view();
        }
     })
     .catch(function (error) {
         console.log(error);
     });
  }else{

  }

}


active_subject_matter(msg){
  var user_id         = msg['user_id'];
  let cutThis         = this;
  var id              = cutThis.props.id;
  var web_token       = window.isNullAndUndef($('#web_token').val());
  if(web_token){
    var body = new FormData();
    body.append('id',id);
    body.append('user_id',user_id);
    body.append('web_token',web_token);
    body.append('function','active_consulting_subject_matter');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
    }else{
      url = "/php/admin_free_consultation_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['code']){
          cutThis.get_user_free_consultation_view();
        }
     })
     .catch(function (error) {
         console.log(error);
     });
  }else{

  }

}

  render() {
    return (
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog popup_view_width">
            <div className="modal-content">
              <div className="modal-header">
              <h4 className="modal-title" id="page_titlte"></h4>
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div className="modal-body">


              <div className="chat-body">
               {this.state.data_view}
              </div>
              {this.state.send_msg}


              </div>
              {/*
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
              </div>
              */}
            </div>
          </div>
        </div>
    );
  }
}

export default FreeConsultationPopup;
